export class PageLoadError extends Error {}

export function loadPage<T>(load: () => Promise<T>, timeoutMs = 20_000): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return Promise.race([
    Promise.resolve().then(load),
    new Promise<never>((_, reject) => {
      timer = setTimeout(() => reject(new Error('Page load timed out')), timeoutMs);
    }),
  ])
    .catch((cause: unknown) => {
      throw new PageLoadError('Page could not be loaded', { cause });
    })
    .finally(() => clearTimeout(timer));
}
